import React, { useEffect, useRef, useState } from 'react';
import { TabPanel } from "primereact/tabview";
import axios from 'axios';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { functionGetParamsCalc, getManagementCosts, updateFees, updateManagementCosts, updateParamsCalc } from '../../functions/functionsFetch';
import { residualValuesCSS } from '../ResidualValues.css';
import { useForm } from 'react-hook-form';
import { GralInput } from '../gralInput/GralInput';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { SkeletonInput } from '../../functions/utils/SkeletonInput';




export const ParamsManagement = ({ managementCosts, feesRes, toast }) => {
    const isInitialMount = useRef(true);

    const { register, handleSubmit, setValue, watch, getValues } = useForm();
    const [loading, setLoading] = useState({
        loading: false,
        loading2: false
    });

    const onSubmit = async (data) => {
        const numericKeyData = Object.keys(data)
            .filter(key => /^\d+$/.test(key))
            .reduce((obj, key) => {
                obj[key] = data[key];
                return obj;
            }, {});
        setLoading({ loading: true, loading2: false });
        if (Object.keys(numericKeyData).length === 0) {
            // Variable is an empty object
            setLoading(false);
            return
        }
        try {
            let result = await updateManagementCosts(numericKeyData);
            if (result?.data.status === 200) {
                toast.current.show({ severity: 'success', summary: ' Ok', detail: 'Valores residuales actualizados' });

            } else {
                toast.current.show({ severity: 'error', summary: ' Error', detail: 'Error al actualizar los valores residuales' });
            }
        } catch (error) {
            toast.current.show({ severity: 'error', summary: ' Error', detail: 'Error al actualizar los valores residuales' });
            console.error('Error updating management costs:', error);
        }

        setLoading({ loading: false, loading2: false });
    };

    const onSubmit2 = async (data) => {


        setLoading({ loading: false, loading2: true });
        const letterKeyData = Object.keys(data)
            .filter(key => /^[a-zA-Z_]+$/.test(key))
            .reduce((obj, key) => {
                obj[key] = data[key];
                return obj;
            }, {});
        let params = Object.entries(letterKeyData).map(([concept_raw, value]) => {
            return {
                "concept_raw": concept_raw,
                "value": parseFloat(value)
            }
        })
        try {
            let result = await updateFees(params);
            if (result?.data.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Ok', detail: 'Valores  actualizados' });
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Error al actualizar los valores' });
            }
        } catch (error) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Error al actualizar los valores ' });
            console.error('Error updating fees:', error);
        }


        setLoading({ loading: false, loading2: false });
    }


    return (<>
        <section css={residualValuesCSS()}>
            <form
                className='w-full '
                onSubmit={handleSubmit(onSubmit)}
            >
                <section className='SectionTable'>

                    {/* {managementCosts.length > 0 ? <> */}

                        <Accordion multiple className='tableAutos'>
                            <AccordionTab header="Ciudad de México - Autos Nuevos">
                                <DataTable
                                    value={managementCosts.cdmxNew}
                                    showGridlines
                                    size='small'
                                    stripedRows
                                >
                                    <Column field="concept" header="Descripcion"></Column>
                                    <Column
                                        field="amount"
                                        header="Monto"
                                        body={({ id, amount }) => {
                                            return <InputText
                                                className='TextInput'
                                                {...register(id.toString())} // Asegúrate de que 'id' sea un string
                                                defaultValue={amount} // Aquí se asegura que 'amount' se muestre en el input
                                            />
                                        }}
                                    />
                                </DataTable>
                            </AccordionTab>
                            <AccordionTab header="Estado de México - Autos Nuevos">
                                <DataTable
                                    value={managementCosts.edoMexNew}
                                    showGridlines
                                    size='small'
                                    stripedRows
                                >
                                    <Column field="concept" header="Descripcion"></Column>
                                    <Column
                                        field="amount"
                                        header="Monto"
                                        body={({ id, amount }) => {
                                            return <InputText
                                                className='TextInput'
                                                {...register(id.toString())} // Asegúrate de que 'id' sea un string
                                                defaultValue={amount} // Aquí se asegura que 'amount' se muestre en el input
                                            />
                                        }}

                                    />
                                </DataTable>
                            </AccordionTab>
                            <AccordionTab header="Morelos - Autos Nuevos">
                                <DataTable
                                    value={managementCosts.morelosNew}
                                    showGridlines
                                    size='small'
                                    stripedRows
                                >
                                    <Column field="concept" header="Descripcion"></Column>
                                    <Column
                                        field="amount"
                                        header="Monto"
                                        body={({ id, amount }) => (
                                            <InputText
                                                className='TextInput'
                                                {...register(id.toString())} // Asegúrate de que 'id' sea un string
                                                defaultValue={amount} // Aquí se asegura que 'amount' se muestre en el input
                                            />
                                        )
                                        }
                                    />
                                </DataTable>
                            </AccordionTab>


                        </Accordion>

                        <Accordion multiple className='tableAutos'>

                            <AccordionTab header="Ciudad de México - Autos Seminuevos">
                                <DataTable
                                    value={managementCosts.cdmxUsed}
                                    showGridlines
                                    size='small'
                                    stripedRows
                                >
                                    <Column field="concept" header="Descripcion"></Column>
                                    <Column
                                        field="amount"
                                        header="Monto"
                                        body={({ id, amount }) => (
                                            <InputText
                                                className='TextInput'
                                                {...register(id.toString())} // Asegúrate de que 'id' sea un string
                                                defaultValue={amount} // Aquí se asegura que 'amount' se muestre en el input
                                            />
                                        )
                                        }
                                    />
                                </DataTable>
                            </AccordionTab>

                            <AccordionTab header="Estado de México - Autos Seminuevos">
                                <DataTable
                                    value={managementCosts.edoMexUsed}
                                    showGridlines
                                    size='small'
                                    stripedRows
                                >
                                    <Column field="concept" header="Descripcion"></Column>
                                    <Column
                                        field="amount"
                                        header="Monto"
                                        body={({ id, amount }) => (
                                            <InputText
                                                className='TextInput'
                                                {...register(id.toString())} // Asegúrate de que 'id' sea un string
                                                defaultValue={amount} // Aquí se asegura que 'amount' se muestre en el input
                                            />
                                        )
                                        }
                                    />
                                </DataTable>
                            </AccordionTab>
                            <AccordionTab header="Morelos - Autos Seminuevos">
                                <DataTable
                                    value={managementCosts.morelosUsed}
                                    showGridlines
                                    size='small'
                                    stripedRows
                                >
                                    <Column field="concept" header="Descripcion"></Column>
                                    <Column
                                        field="amount"
                                        header="Monto"
                                        body={({ id, amount }) => (
                                            <InputText
                                                className='TextInput'
                                                {...register(id.toString())} // Asegúrate de que 'id' sea un string
                                                defaultValue={amount} // Aquí se asegura que 'amount' se muestre en el input
                                            />
                                        )
                                        }
                                    />
                                </DataTable>
                            </AccordionTab>
                        </Accordion> 
                        {/* </>  : <SkeletonInput /> */}


                </section>

                <div className="ButtonWithShadow">
                    <Button label="Continuar" icon="pi pi-check" loading={loading.loading} className='Green py-3 mt-4 W-4/5' type='submit' />

                    <div className="Shadow"></div>
                </div>
            </form>
            <section className='mt-10'>
                <h2 className='text-xl font-bold mb-10'>CAT Tramites Vehiculares</h2>

                <form onSubmit={handleSubmit(onSubmit2)}
                    className='w-[100%]'>
                    <div className='flexConteiner grid-cols-1 md:grid-cols-2 lg:grid-cols-3 w-4/5 gap-8 mx-auto'>
                        <GralInput arr={feesRes} register={register} />

                    </div>


                    <div className="ButtonWithShadow">
                        <Button label="Continuar" icon="pi pi-check" loading={loading.loading2} className='Green py-3 mt-4 W-4/5' type='submit' />

                        <div className="Shadow"></div>
                    </div>
                </form>

            </section>
        </section>

    </>
    );
};